import React, { useEffect } from 'react';
import Lottie from 'lottie-react';
import loadingAnimation from '../../../assets/animations/loading.json';
import successAnimation from '../../../assets/animations/successful.json';
import notFoundAnimation from '../../../assets/animations/notfound.json';

const animations = {
  loading: { data: loadingAnimation, loop: true },
  success: { data: successAnimation, loop: false },
  notfound: { data: notFoundAnimation, loop: true },
};

const Animations = ({ type = 'loading', onComplete }) => {
  const current = animations[type];

  useEffect(() => {
    if (type === 'success' && onComplete) {
      const timer = setTimeout(() => {
        onComplete();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [type, onComplete]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      width: '100vw',
      backgroundColor: '#fffefeff'
    }}>
      <Lottie
        animationData={current.data}
        loop={current.loop}
        style={{ width: 200, height: 200 }}
      />
    </div>
  );
};

export default Animations;